import { ArrowRight, Cloud, PanelsTopLeft, ServerCog } from 'lucide-react'
import { EnvironmentExplorer } from '../components/EnvironmentExplorer'
import { PageHero } from '../components/PageHero'
import { PageMeta } from '../components/PageMeta'
import { technologies } from '../content/site'

export function ExpertisePage() {
  return (
    <main id="main-content" className="route-page">
      <PageMeta
        title="Technology expertise"
        description="Informat works across cloud, on-premises and hybrid environments using fit-for-purpose Microsoft, Google, Zoho, UniFi, Wix and other technology."
      />
      <PageHero
        className="expertise-hero"
        title={
          <>
            Technology selected for the job. Not the other way around.
            <span className="text-cursor" aria-hidden="true" />
          </>
        }
        body="Every environment is different. We work from your requirements, existing systems and plans, then bring together technology that fits."
        visual={<EnvironmentExplorer />}
      />
      <section className="technology-landscape section-light" aria-labelledby="landscape-title">
        <h2 id="landscape-title" data-reveal>
          Experience across the technology landscape.
        </h2>
        <div className="technology-list" data-reveal>
          {technologies.map((technology) => (
            <span key={technology}>{technology}</span>
          ))}
        </div>
        <p className="technology-list__other">and other fit-for-purpose platforms</p>
        <div className="expertise-rails">
          <article data-reveal>
            <Cloud aria-hidden="true" strokeWidth={1.2} />
            <h3>Cloud & workplace</h3>
            <ul>
              <li>Email, messaging and collaboration</li>
              <li>Identity, access and administration</li>
              <li>Files, information and productivity</li>
              <li>Devices and endpoints</li>
            </ul>
          </article>
          <article data-reveal>
            <ServerCog aria-hidden="true" strokeWidth={1.2} />
            <h3>Infrastructure & networks</h3>
            <ul>
              <li>Virtualised environments and servers</li>
              <li>Cloud, on-premises and hybrid systems</li>
              <li>Networks, Wi-Fi, VLANs and guest access</li>
              <li>Remote access and documentation</li>
            </ul>
          </article>
          <article data-reveal>
            <PanelsTopLeft aria-hidden="true" strokeWidth={1.2} />
            <h3>Business platforms</h3>
            <ul>
              <li>CRM and customer systems</li>
              <li>Websites and digital experience</li>
              <li>Digital phones and communications</li>
              <li>AI, automation and integrations</li>
            </ul>
          </article>
        </div>
      </section>
      <section className="microsoft-depth section-dark" id="microsoft">
        <div data-reveal>
          <h2>Specialist depth for complex Microsoft environments.</h2>
          <p>
            Active Directory, Entra ID, Microsoft 365, Intune, Windows Server, identity,
            infrastructure, migration, remediation, automation and technical documentation.
          </p>
        </div>
        <a href="/contact?topic=microsoft">
          Discuss your environment <ArrowRight aria-hidden="true" />
        </a>
      </section>
    </main>
  )
}
